import { is } from 'ramda'
import type { CustomEventsContext } from '../types'

// data structure: { version: int | undefined, plans: Array<{ id: string, price: string }> }

export default function (this: CustomEventsContext, plans: unknown) {
  return this.sendEventWithCallback('subscription.plans', { api_plans: plans })
    .then((data: unknown) => {
      const d = data as { plans?: unknown }
      if (is(Array, d.plans)) {
        return data
      }
      return Promise.reject(
        new Error(this.ERROR_UNKNOWN)
      )
    })
}
